import { render } from "./AllNotifications.vue?vue&type=template&id=7e37e821"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__